<template>
    <div class="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <AppNavbar />
  
      <div class="max-w-6xl mx-auto">
        <h1 class="text-3xl font-bold text-teal-700 mb-6 text-center">Appointments</h1>
  
        <!-- 🔍 Search + Filters -->
        <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
          <input
            v-model="searchTerm"
            type="text"
            placeholder="Search by patient name..."
            class="w-full md:w-1/2 p-2 border border-gray-300 rounded text-sm"
          />
  
          <select
            v-model="filterStatus"
            class="p-2 border border-gray-300 rounded text-sm"
          >
            <option value="">All</option>
            <option value="pending">Only Pending</option>
            <option value="completed">Only Completed</option>
          </select>
        </div>
  
        <!-- 📋 Appointments Grid -->
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div
            v-for="(appt, index) in filteredAppointments"
            :key="index"
            class="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition"
          >
            <div class="flex justify-between items-center mb-2">
              <h2 class="text-lg font-semibold text-gray-800">{{ appt.name }}</h2>
              <span
                class="px-3 py-1 text-sm rounded-full"
                :class="appt.completed ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'"
              >
                {{ appt.completed ? 'Completed' : 'Pending' }}
              </span>
            </div>
  
            <p class="text-gray-600 mb-1">📅 {{ appt.date }}</p>
            <p class="text-gray-600 mb-1">📞 {{ appt.phone }}</p>
            <p class="text-gray-600 mb-4">📧 {{ appt.email }}</p>
  
            <textarea
              v-model="appt.remarks"
              placeholder="Add remarks..."
              class="w-full p-2 border border-gray-300 rounded mb-3 text-sm"
            ></textarea>
  
            <label class="text-sm text-gray-600 block mb-1">Follow-up Date</label>
            <input
              type="date"
              v-model="appt.followUpDate"
              class="w-full p-2 border border-gray-300 rounded mb-4"
            />
  
            <div class="flex justify-between">
              <button
                @click="toggleCompletion(index)"
                class="text-sm bg-teal-600 text-white px-3 py-1 rounded hover:bg-teal-700"
              >
                {{ appt.completed ? 'Undo Complete' : 'Mark as Completed' }}
              </button>
  
              <button
                @click="viewDetails(appt)"
                class="text-sm bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
              >
                View Details
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  

<script>
import AppNavbar from "@/components/Navbar.vue";

export default {
  name: "DashboardView",
  components: {
    AppNavbar,
  },
  data() {
    return {
      searchTerm: "",
      filterStatus: "", // '', 'pending', 'completed'
      appointments: [
        {
          name: "Ananya Roy",
          phone: "+91 99999 11111",
          email: "ananya@example.com",
          date: "2025-07-20",
          completed: false,
          remarks: "",
          followUpDate: "",
        },
        {
          name: "Rahul Mehra",
          phone: "+91 88888 22222",
          email: "rahul@example.com",
          date: "2025-07-22",
          completed: true,
          remarks: "Needs review in 2 weeks",
          followUpDate: "2025-08-05",
        },
      ],
    };
  },
  computed: {
    filteredAppointments() {
      return this.appointments.filter((appt) => {
        const nameMatch = appt.name.toLowerCase().includes(this.searchTerm.toLowerCase());
        const statusMatch =
          this.filterStatus === ""
            || (this.filterStatus === "pending" && !appt.completed)
            || (this.filterStatus === "completed" && appt.completed);
        return nameMatch && statusMatch;
      });
    },
  },
  methods: {
    toggleCompletion(index) {
      this.appointments[index].completed = !this.appointments[index].completed;
    },
    viewDetails(appointment) {
      alert(
        `Name: ${appointment.name}\nPhone: ${appointment.phone}\nEmail: ${appointment.email}\nDate: ${appointment.date}`
      );
    },
  },
};
</script>
